/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*
*/
import { HttpParams } from "@angular/common/http";
import { MyInjector } from "@src/app/app.module";
import { SraChart } from "@src/app/modules/agent/agent-dashboard-page/SraChart";
import { TenantService } from "@src/app/shared/tenant.service";

export class SraOmcChart extends SraChart {
    title = "My OMC Requests";
    tenantSvc = MyInjector.instance.get(TenantService);
    dataParams = new HttpParams().set('week', 0).set('show', this.tenantSvc.getCurrentTenantId()).set('days', 30);    
}